var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor timeout" },
    [
      _c("a-alert", {
        attrs: {
          message: "Dikkat Edilmesi Gereken!",
          description:
            "Varsayılan Zaman Aşımı, Normal Zaman Aşımı bloğundan küçük olamaz ve Zaman Aşımı blokları ayarlardaki 'Pasif Chat Süresi' ve 'Pasif Chat Kapatma Süresi' toplamından küçük olamaz. Bu kurallar çervesine uyulmaz ise blok çalışmadan sohbet kapanma gibi durumlar olabilir!",
          type: "warning",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v("Zaman Aşımı (Saniye)"),
          ]),
          _vm._v(" "),
          _c("a-input-number", {
            staticClass: "input-number",
            attrs: { min: _vm.minimunTimeout },
            model: {
              value: _vm.clone.timeout,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "timeout", $$v)
              },
              expression: "clone.timeout",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }